module.exports = __webpack_public_path__ + "static/img/mengzhengfile.ba3bae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mengzhengfile.png
// module id = VIMs
// module chunks = 3